import React, { type InputHTMLAttributes, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import InputRenderer from "src/shared/forms/formrenderers/InputRenderer";
import type IFormInputs from "src/shared/forms/inputs/IFormInputs";
import { length as Length } from "src/shared/forms/validations/Length";
import Regex from "src/shared/forms/validations/Regex";
import { required as Required } from "src/shared/forms/validations/Required";

const MIN_ADDRESS_POSTAL_CODE_CHARS: number | undefined = undefined;
const MAX_ADDRESS_POSTAL_CODE_CHARS: number | undefined = 16;
const PostalCodeLengthValidation = Length(
  MIN_ADDRESS_POSTAL_CODE_CHARS,
  MAX_ADDRESS_POSTAL_CODE_CHARS,
);

const PostalCodeRegexValidation = Regex(
  new RegExp("^[a-zA-Z0-9 -]*$"),
  <FormattedMessage id="form.validations.postal_code.invalid" />,
);

export interface IPostalCodeInputProps
  extends IFormInputs,
    InputHTMLAttributes<HTMLInputElement> {
  isRequired?: boolean;
}

export default (props: IPostalCodeInputProps) => {
  const {
    inputID,
    label = <FormattedMessage id="contacts.postal_code" />,
    validationDisabled = false,
    isRequired = true,
    ...rest
  } = props;

  const validations = useMemo(() => {
    if (validationDisabled) {
      return undefined;
    }

    const validations = [PostalCodeLengthValidation, PostalCodeRegexValidation];
    if (isRequired) {
      validations.push(Required);
    }
    return validations;
  }, [isRequired, validationDisabled]);

  return (
    <Field
      name={inputID}
      label={label}
      type="text"
      component={InputRenderer}
      validate={validations}
      {...rest}
    />
  );
};
